{
	"type": "line",
	"minzoom": 8,
	"filter": [
		"match",
		["get", "lay_class"],
		[
			"Aboriginal Place of Heritage Significance",
			"Conservation Area - Aboriginal",
			"Conservation Area - General",
			"Conservation Area - Landscape",
			"Heritage Conservation Area"
		],
		true,
		false
	],
	"layout": {},
	"paint": {
		"line-color": [
			"match",
			["get", "lay_class"],
			["Aboriginal Place of Heritage Significance", "Conservation Area - Aboriginal"],
			"#ffc700",
			["Conservation Area - Landscape", "Heritage Conservation Area"],
			"#046a00",
			"#e30000"
		],
		"line-width": [
			"match",
			["get", "lay_class"],
			["Aboriginal Place of Heritage Significance", "Conservation Area - Aboriginal"],
			1.4,
			1
		],
		"line-dasharray": [
			"match",
			["get", "lay_class"],
			["Aboriginal Place of Heritage Significance", "Conservation Area - Aboriginal"],
			["literal", [1.6, 1.4]],
			["literal", [1]]
		]
	}
}
